<div class="bl-new-modal">
    <img src="../../../assets/images/cadeau.png" alt="">
    <div>
        <h1>NEW!</h1>
        <p>
            Reserve a recurring slot for FREE and take laundry off your to-do list forever!
        </p>
    </div>

</div>